module.exports = __webpack_public_path__ + "static/img/LeadTed.1c061f7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gifs/LeadTed.gif
// module id = g+4A
// module chunks = 1